import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Loader, Segment, Divider} from 'semantic-ui-react';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Alert} from 'componentLibrary';
import ApiActions from 'go/actions/api';
import {API_SAMGOV_GET_SUCCESS} from 'common/types';

export class PreAwardSamGovReviewPanel extends Component {
  componentDidMount() {
    if (this.props.duns || this.props.uei) {
      this.initializeSamgov();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.duns !== prevProps.duns || this.props.uei !== prevProps.uei) {
      this.initializeSamgov();
    }
  }

  initializeSamgov = () => {
    let {getSamgov, token, duns, saveEntitySessionData, uei, eft, toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    getSamgov(token, duns, uei, eft, dunsToUEIToggle)
      .then((samgov) => {
        if (samgov.type === API_SAMGOV_GET_SUCCESS) {
          saveEntitySessionData('context.samgov', samgov.payload);
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  renderDebtSubjectToOffset(samgov) {
    const debtSubjectToOffset = _.get(samgov, ['debtSubjectToOffset']);
    let debtDisplay = null;
    if (debtSubjectToOffset === 'Yes' || debtSubjectToOffset === 'Y') {
      debtDisplay = 'Yes';
    } else {
      debtDisplay = 'No';
    }
    return (
      <React.Fragment>
        Delinquent on Federal debt?
        <br />
        <b>{debtDisplay}</b>
        {debtDisplay === 'Yes' && (
          <Alert
            type="warning"
            header="Delinquent on debt"
            content="The applicant is delinquent in a debt to the United States as defined in OMB Guidance A-129."
          />
        )}
      </React.Fragment>
    );
  }

  renderHasKnownExclusion(samgov) {
    const hasKnownExclusion = _.get(samgov, ['hasKnownExclusion']);
    return (
      <React.Fragment>
        Suspended or debarred party?
        <br />
        <b>{hasKnownExclusion}</b>
        {hasKnownExclusion === 'Yes' && (
          <Alert
            type="error"
            header="Excluded party"
            content="The applicant is debarred, suspended, or otherwise excluded 
          from or ineligible for participation in Federal assistance programs or activities."
          />
        )}
      </React.Fragment>
    );
  }

  renderDunsExpiration(samgov) {
    return (
      <p>
        Registration expiration
        <br />
        <b>{_.get(samgov, ['DUNS Expiration'])}</b>
      </p>
    );
  }

  renderRegistrationStatus(samgov) {
    const registrationStatus = _.get(samgov, 'SAM.gov Registration Status');
    const registrationStatusText = registrationStatus
      ? registrationStatus
      : 'Retrieving registration status.';
    return (
      <React.Fragment>
        SAM.gov registration status
        <br />
        <b>{registrationStatusText}</b>
        {(registrationStatus === 'Inactive' || registrationStatus === 'Expired') && (
          <Alert
            type="warning"
            header="SAM.gov registration"
            content="The SAM.gov account is not active. The SAM.gov Registration Funding Hold special condition should be applied to this grant in order to prevent payment until the registration is active."
          />
        )}
      </React.Fragment>
    );
  }

  renderComponent(samgov) {
    return (
      <React.Fragment>
        Review the recipient's SAM.gov profile
        <br />
        <br />
        {this.renderRegistrationStatus(samgov.samgov)}
        <Divider />
        {this.renderDunsExpiration(samgov.samgov)}
        <Divider />
        {this.renderHasKnownExclusion(samgov)}
        <Divider />
        {this.renderDebtSubjectToOffset(samgov)}
      </React.Fragment>
    );
  }

  render() {
    const {data: samgov, duns, uei, toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    if ((dunsToUEIToggle && !uei) || (!dunsToUEIToggle && !duns)) {
      return (
        <div class="errorBorderLine">
          Review the recipient's SAM.gov profile
          <br />
          <div class="errorMessages">
            The application has not been linked to a vendor. You must link the application
            to a vendor before reviewing the SAM.gov profile information
          </div>
        </div>
      );
    } else if (samgov && !samgov.loading) {
      return this.renderComponent(samgov);
    } else {
      return (
        <Segment vertical padded>
          <Loader active>Loading...</Loader>
        </Segment>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getSamgov: (token, duns, uei, eft, dunsToUEIToggle) => {
      let action = dunsToUEIToggle
        ? !_.isEmpty(uei) && !_.isEmpty(_.trim(eft))
          ? ApiActions.vendor.getSamgovInfoForUeiAndEft(token, uei, eft)
          : ApiActions.vendor.getSamgovInfoForUei(token, uei)
        : ApiActions.vendor.getSamgovInfoForDuns(token, duns);
      const response = dispatch(action);
      return response;
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(PreAwardSamGovReviewPanel));
